import React from "react";
import Navbar1 from "../firstnavbar/FirstNavbar";
import Navbar from "../Navbar/Navbar";
import Carosello from "../carosello/Carosello";
import { Container, Row, Col } from "react-bootstrap";
import "./home.css";
import Footer from "../footer/Footer";
import Cartina from "../map/Cartina.jsx";
import Card from "../card/Card.jsx";

import LanguageSelector from "../../Language/LanguageSelector.jsx";
import { useTranslation } from "react-i18next";

const Home = () => {
  const { t } = useTranslation();

  return (
    <>
      <Navbar1 />
      <Navbar />
      <Carosello />
      <LanguageSelector></LanguageSelector>
      <h2 id="h1">{t("Title")}</h2>
      <p id="p1">"{t("titlep")}"</p>
      <div className="loader">
        <div className="circle">
          <div className="dot"></div>
          <div className="outline"></div>
        </div>
        <div className="circle">
          <div className="dot"></div>
          <div className="outline"></div>
        </div>
        <div className="circle">
          <div className="dot"></div>
          <div className="outline"></div>
        </div>
        <div className="circle">
          <div className="dot"></div>
          <div className="outline"></div>
        </div>
      </div>
      <hr />
      <Container id="contenitore1">
        <Row style={{ display: "flex", alignItems: "center" }} id="row1">
          <Col xs="12" md="6" id="colimg">
            <img src="/img/immagini/camino.png" id="img1" alt="vista" />
          </Col>
          <Col xs="12" md="6" id="colimg">
            <div className="p2" id="p2">
              <h2 style={{ textAlign: "center" }}>{t("t2")}</h2>
              <p id="p2">{t("p2")}</p>
            </div>
          </Col>
        </Row>
        <Row style={{ display: "flex", alignItems: "center" }} id="row1">
          <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 1 }} id="colimg">
            <div className="p2" id="p2">
              <h2 style={{ textAlign: "center" }}>{t("t3")}</h2>
              <p id="p2">{t("p3")}</p>
            </div>
          </Col>
          <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }} id="colimg">
            <img src="/img/immagini/maialetto.png" id="img1" alt="vista" />
          </Col>
        </Row>
        <Row style={{ display: "flex", alignItems: "center" }} id="row1">
          <Col xs="12" md="6" id="colimg">
            <img src="/img/immagini/casu.png" id="img1" alt="vista" />
          </Col>
          <Col xs="12" md="6" id="colimg">
            <div className="p2" id="p2">
              <h2 style={{ textAlign: "center" }}>{t("t4")}</h2>
              <p id="p2">{t("p4")}</p>
            </div>
          </Col>
        </Row>
        <Row style={{ display: "flex", alignItems: "center" }} id="row1">
          <Col xs={{ span: 12, order: 2 }} md={{ span: 6, order: 1 }} id="colimg">
            <div className="p2" id="p2">
              <h2 style={{ textAlign: "center" }}>{t("t5")}</h2>
              <p id="p2">{t("p5")}</p>
            </div>
          </Col>
          <Col xs={{ span: 12, order: 1 }} md={{ span: 6, order: 1 }} id="colimg">
            <img src="/img/immagini/primi.png" id="img1" alt="vista" />
          </Col>
        </Row>

        {/*  <div className="pavoncella">
          <img src="/img/immagini/pavoncella.png" alt="pavoncella" id="pavoncella"></img>
        </div> */}

        <Card></Card>
        <hr></hr>

        <div className="pizza">
          <h1 id="pizza1">{t("pizzatitle")}</h1>
          <i>
            {" "}
            <p id="location">{t("pizzatvia")}</p>
          </i>
          <p id="p2">{t("pizzap")}</p>
          <Row id="lastrow">
            {" "}
            <Col xs="12" md="6">
              {" "}
              <img src="./img/immagini/pizza.png" id="pizza" alt=""></img>
            </Col>
            <Col xs="12" md="6">
              {" "}
              <img src="./img/immagini/pizza1.png" id="pizza" alt=""></img>
            </Col>
          </Row>
        </div>
        <hr></hr>
      </Container>
      <Cartina />
      <div className="footer" id="end"></div>
      <Footer />
    </>
  );
};

export default Home;
